import ymaps from 'ymaps';

export default function () {
  return ymaps.templateLayoutFactory.createClass(`
    <div class="balloon-content">
      <div class="balloon-content__part">
        <div class="part">
          <div class="part__number"></div>
          <div class="part__title">Контакты</div>
        </div>
      </div>
      <div class="balloon-content__description">
        $[properties.content]
      </div>
    </div>
  `);
}
